import styled from "styled-components";

export const StyledList = styled.ul`
  width: 100%;
`;

export const StyledListItem = styled.li`
  margin-bottom: ${({ theme }) => theme.space.sm};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: ${({ theme }) => theme.space.lg};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
